import React from "react";

import { Button, Icon } from "@culturehq/components";
import { Trans } from "app/utils";

type PostStoryModalButtonGetStartProps = {
  onNextStep: () => void;
};

const PostStoryModalButtonGetStart: React.FC<PostStoryModalButtonGetStartProps> = ({
  onNextStep
}) => (
  <Button className="NextBtn Get-started__btn" onClick={onNextStep}>
    <Trans>Let&apos;s get started</Trans>
    <Icon className="arrow-icon" icon="arrow-left-c" />
  </Button>
);

export default PostStoryModalButtonGetStart;
